<template>
  <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
    <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
      <h2 class="text-xl sm:text-2xl font-bold mb-4 text-gray-800">Add Staff</h2>
      <form @submit.prevent="add" class="flex flex-col space-y-4">
        <input v-model="staff.name" class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green" placeholder="Names" required />
        <input v-model="staff.phone" class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green" placeholder="Phone" required />
        <input v-model="staff.email" class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green" placeholder="Email" required />
        <input v-model="staff.address" class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green" placeholder="Address" required />
        <input type="password" v-model="staff.password" class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green" placeholder="Password" required />
        <div class="relative">
          <input type="password" v-model="staff.repeatedPassword" class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green" placeholder="Repeat Password" required />
          <span v-if="staff.repeatedPassword && staff.repeatedPassword !== staff.password" class="absolute right-2 top-1/2 transform -translate-y-1/2 text-red-500">&#9888;</span>
        </div>
        <button type="submit" class="bg-green text-white p-2 sm:p-3 rounded-lg hover:bg-green-500 w-full">
          Add Staff
        </button>
      </form>
      <button @click="closeModal" class="mt-4 text-gray-600">Cancel</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';


export default {
  props: {
  },
  data() {
    return {
      staff: {
        name: '',
        phone: '',
        email: '',
        address: '',
        password: '',
        repeatedPassword: '',
      },
    };
  },
  methods: {
    ...mapActions('staffs', {
      addStaff: 'addStaff',
    }),
    closeModal() {
      this.$emit('closeModal'); // Emit event to close the modal
      this.resetForm(); // Reset form on close
    },
    resetForm() {
      this.staff = {
        name: '',
        phone: '',
        email: '',
        address: '',
        password: '',
        repeatedPassword: '',
      };
    },
    async add() {
      try {
        console.log(`...adding staff`)
        await this.addStaff(this.staff);
        this.closeModal(); // Close modal after adding
        // Optionally refresh or fetch updated staff list here
      } catch (error) {
        console.error('Error adding staff:', error);
        // Handle error (e.g., display a message)
      }
    },
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
